// Guard so this file can also load standalone (e.g. the gift redemption funnel
// reuses the MM/YYYY masking + validation helpers). In bb-funnel-v2
// window.SubscriptionFunnel is already set before this script, so this
// assignment is a no-op there.
window.SubscriptionFunnel = window.SubscriptionFunnel || {};

window.SubscriptionFunnel.StepBirthday = {
  validateMMYYYY(input) {
    const regex = /^(0[1-9]|1[0-2])\/\d{4}$/;
    if (!regex.test(input)) {
      return false;
    }
    const [month, year] = input.split("/");
    const yearNum = parseInt(year, 10);
    const currentYear = new Date().getFullYear();
    return yearNum >= 1900 && yearNum <= currentYear + 100;
  },

  isDateInFuture(input) {
    const [month, year] = input.split("/");
    const yearNum = parseInt(year, 10);
    const monthNum = parseInt(month, 10);
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1; // getMonth() returns 0-11
    
    // Check if year is in the future
    if (yearNum > currentYear) {
      return true;
    }
    // Check if it's current year but month is in the future
    if (yearNum === currentYear && monthNum > currentMonth) {
      return true;
    }
    
    return false;
  },

  formatMMYYYY(input) {
    input = input.replace(/\D/g, "").slice(0, 6);
    if (input.length > 2) {
      return input.slice(0, 2) + "/" + input.slice(2);
    }
    return input;
  },

  handleBirthdayInput(inputElement, errorElement) {
    inputElement.addEventListener("input", (event) => {
      let value = event.target.value;
      let formattedValue = this.formatMMYYYY(value);
      event.target.value = formattedValue;

      if (formattedValue.length === 7) {
        if (this.validateMMYYYY(formattedValue)) {
          event.target.classList.remove("text-input-component-input--error");
          event.target.setAttribute("aria-invalid", "false");
          errorElement.classList.add("display-none");
        } else {
          event.target.classList.add("text-input-component-input--error");
          event.target.setAttribute("aria-invalid", "true");
          errorElement.classList.remove("display-none");
        }
      } else {
        event.target.classList.remove("text-input-component-input--error");
        event.target.setAttribute("aria-invalid", "false");
        errorElement.classList.add("display-none");
      }
    });

    inputElement.addEventListener("blur", (event) => {
      if (event.target.value.trim() === "") {
        event.target.classList.add("text-input-component-input--error");
        event.target.setAttribute("aria-invalid", "true");
        errorElement.textContent = "Error: Required field.";
        errorElement.classList.remove("display-none");
      }
    });
  },

  validateBirthdayAndProceed() {
    const dogBirthdayInput = document.getElementById("dog-birthday");
    const errorElement = document.getElementById("dog-birthday-error");
    const dogBirthday = dogBirthdayInput.value.trim();

    if (dogBirthday === "" || this.validateMMYYYY(dogBirthday)) {
      // Birthday is either empty (optional) or valid
      errorElement.classList.add("display-none");
      dogBirthdayInput.classList.remove("text-input-component-input--error");
      dogBirthdayInput.setAttribute("aria-invalid", "false");

      // Store the dog's birthday in the quizData object
      quizData.dogBirthday = dogBirthday;

      // Proceed to the next step
      SubscriptionFunnel.FunnelNavigation.nextStep();
    } else {
      // Invalid birthday
      errorElement.classList.remove("display-none");
      dogBirthdayInput.classList.add("text-input-component-input--error");
      dogBirthdayInput.setAttribute("aria-invalid", "true");
    }
  },
};

// Initialize validation on page load
document.addEventListener("DOMContentLoaded", () => {
  const dogBirthdayInput = document.getElementById("dog-birthday");
  const errorElement = document.getElementById("dog-birthday-error");

  if (dogBirthdayInput && errorElement) {
    window.SubscriptionFunnel.StepBirthday.handleBirthdayInput(
      dogBirthdayInput,
      errorElement
    );
  }
});
